import React, { createContext, useState, useContext } from 'react';
import { getText, formatText } from '../config/texts';

// Création du contexte de langue
const LanguageContext = createContext();

// Fournisseur du contexte de langue
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr'); // Langue par défaut: français

  // Fonction pour changer la langue
  const changeLanguage = (lang) => {
    if (lang === 'fr' || lang === 'en') {
      setLanguage(lang);
    }
  };

  // Fonction pour obtenir un texte dans la langue actuelle
  const t = (path, variables) => {
    const text = getText(language, path);
    return variables ? formatText(text, variables) : text;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte de langue
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage doit être utilisée à l\'intérieur d\'un LanguageProvider');
  }
  return context;
};
